import { useRoutes } from "react-router-dom";

import HomePage from "./pages/home";
import Event from "./pages/Event";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Profile from "./pages/Profile";
import AdmissonG from "./pages/AdmissonG";
import EventDetails from "./pages/event-details/event-detals";
import CircularPage from "./pages/notice/circular";
import PrincipalMessagePage from "./pages/principal_message";
import AboutCollegePage from "./pages/about_college";
import MissionVisionPage from "./pages/mission_vision_page";
import CourseDetailsPage from "./pages/CourseDetailsPage";
import CoursesListPage from "./pages/course_list.js";
import MissionPage from "./pages/mission.js";
import VisionPage from "./pages/vision.js";
import FeeStructurePage from "./pages/fee-structure/page.jsx";
import SyllabusPage from "./pages/SyllabusPage.jsx";
import Error404 from "./pages/404.js";
import appRoutes from "./routes/appRoutes";

const componentMap = {
  "/": <HomePage />,
  "/event": <Event />,
  "/contact": <Contact />,
  "/about": <About />,
  "/admission": <AdmissonG />,
  "/feestructure": <FeeStructurePage />,
  "/profile": <Profile />,
  "/notice": <Profile />,
  "/event-details": <EventDetails />,
  "/circular": <CircularPage />,
  "/principalmessage": <PrincipalMessagePage />,
  "/aboutcollege": <AboutCollegePage />,
  "/mission": <MissionPage />,
  "/vision": <VisionPage />,
  "/missionvision": <MissionVisionPage />,
  "/syllabus": <SyllabusPage />,
  "/courses": <CoursesListPage />,
  "/courses/:slug": <CourseDetailsPage />,
"*":
<Error404 />,

};

export default function Router() {
  const routes = appRoutes.map((r) => ({
    path: r.path,
    element: componentMap[r.path],
  }));

  return useRoutes(routes);
}
